/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable react/jsx-props-no-spreading */
import { z } from 'zod';
import React, { useRef, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { InputField } from '../Forms/Fields';
import { getCSRF, injectCleanedFieldToForm } from '../../utils/forms';
import { ShowPasswordButton } from '../Forms/ShowPasswordButton';
import { getCookie } from '../../utils/cookies';

const loginValidationSchema = z.object({
  email: z.string().min(4, { message: 'Este campo es requerido' }).email('Ingresa un correo electrónico válido'),
  password: z.string().min(1, { message: 'Este campo es requerido' }),
});

type LoginValues = z.infer<typeof loginValidationSchema>;

export function LoginForm() {
  const [showPassword, setShowPassword] = useState(false);
  const methods = useForm<LoginValues>({
    resolver: zodResolver(loginValidationSchema),
  });

  const handleToggleShowPassword = () => setShowPassword(!showPassword);
  const handleValidateErrors = () => methods.formState.errors;

  const formRef = useRef<HTMLFormElement>(null);
  const { name: CSRFName, value: CSRFValue } = getCSRF();

  const onSubmit = () => {
    const cookie = getCookie('csrftoken');
    if (formRef.current) {
      injectCleanedFieldToForm({ form: formRef.current, name: CSRFName, value: cookie });
    }
    formRef.current?.submit();
  };

  return (
    <FormProvider {...methods}>
      <form
        ref={formRef}
        id="login-form"
        className="mx-auto d-flex flex-column align-items-center justify-content-center gap-4 mb-4 "
        action=""
        method="post"
        onSubmit={methods.handleSubmit(onSubmit)}
      >
        <input type="hidden" name={CSRFName} value={CSRFValue} />

        <InputField<LoginValues>
          path="email"
          placeholder="Email"
          id="email"
        />

        <InputField<LoginValues>
          path="password"
          placeholder="Clave"
          type={showPassword ? 'text' : 'password'}
          id="password"
          endAdornment={() => (
            <ShowPasswordButton
              isShowing={showPassword}
              onClick={handleToggleShowPassword}
            />
          )}
        />

        <button type="submit" onClick={handleValidateErrors} className="btn btn-primary w-100 rounded-2 p-2 fw-bold">Ingresar</button>
      </form>

    </FormProvider>
  );
}
